// $(window).on('load', function () {

//    const audioplay = $('#loader-audio')[0];

//     // audioplay.play();
//   $('#loader-audio').trigger("play");

//   setTimeout(() => {
//        $('.loader-mask').fadeOut('');
//   $('html').addClass("html_hidden");
//   }, "2500");
 
// });



$(window).on('load', function () {
    var textToRemove = "Photo & Video";
    $('html[lang="en"]  .list-menu .list-menu li').filter(function() {
        return $(this).text().trim() === textToRemove;
    }).hide();
});


  
$(window).on('load', function(){
  setTimeout(() => {
       $('.OS_contact_title').delay(1880).addClass('zoomin_hand');
       $('.OS_contact_form').addClass('anim_fade');
  }, "2800");

   $('.footer_fixed_header, .header_drawer_btn ').click(function(){
       if($('body').hasClass('overflow-hidden-desktop')){
         $('html').addClass('menu_open');
       } else{
          $('html').removeClass('menu_open');
       }
    })
    //  $('.header_drawer_btn').click(function(){
    //     $('html').toggleClass('menu_open');
    // })
 
})

$(window).scroll(function() {
if ($(this).scrollTop() > 50){  
    $('html').addClass("header_sticky");
  }
  else{
    $('html').removeClass("header_sticky");
  }
});

// $(document).ready(function() {
//   $('.close_menu_icon').on('click', function() {
//     $('.menu-drawer-container').removeClass('menu-opening');
//     $('.menu-drawer-container').removeAttr('open');
//   });
// });


// var featured_top = $(".featured_work_section").position().top - 500;
// $(window).scroll(function(){
//     if($(this).scrollTop() >= featured_top){
//         $(".featured_work_section").addClass("anim");
//         $(".featured_work_section").removeClass("anim_off");
//     } else {
//         $(".featured_work_section").removeClass("anim");
//     }
// });

$(document).ready(function() {
  if ($(window).width() <= 1200) {
    // Wrap elements with data-object attributes 'obj0', 'obj1', 'obj2' into one div
    $(".footer-animation-wrapper [data-object='obj0'], .footer-animation-wrapper [data-object='obj1'], .footer-animation-wrapper [data-object='obj3']").wrapAll("<div class='footer-animation_mobile_wrapper mobile-animation_left' />");
    
    // Wrap elements with data-object attributes 'obj3', 'obj4' into another div
    $(".footer-animation-wrapper [data-object='obj2'], .footer-animation-wrapper [data-object='obj4']").wrapAll("<div class='footer-animation_mobile_wrapper mobile-animation_right' />");
  }
});

$(document).ready(function(){

  // if ($(window).width() <= 1200) {
  //   $(".footer-animation-wrapper [data-object='obj0'], footer-animation-wrapper [data-object='obj1'], footer-animation-wrapper [data-object='obj2']").wrapAll( "<div class='footer-animation_mobile_wrapper mobile-animation_left' />");
  //   $(".footer-animation-wrapper [data-object='obj3'], footer-animation-wrapper [data-object='obj4']").wrapAll( "<div class='footer-animation_mobile_wrapper mobile-animation_right' />");
  // }
  
  AOS.init();
  $('.logo_silder_flex').slick({
    autoplay: true,
    infinite: true,
    autoplaySpeed: 0,
    speed: 5000,
    arrows: false,
    swipe: false,
    variableWidth: true,
    slidesToShow: 5,
    cssEase: 'linear',
    centerMode: true,
    centerPadding: '100px',
    pauseOnFocus: false,
    pauseOnHover: false,
     responsive: [
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 2,
      }
    }
  ]
  });

  $('.marquee_flex').slick({
    autoplay: true,
    infinite: true,
    autoplaySpeed: 0,
    speed: 12000,
    arrows: false,
    swipe: false,
    slidesToShow: 1,
    cssEase: 'linear',
    pauseOnFocus: false,
    pauseOnHover: false,
  });
  

  // $('.OS-explore-slider').slick({
  //  slidesToShow: 2,
  //  infinite:false,
  //  slidesToScroll: 1,
  //  autoplay: false,
  //  autoplaySpeed: 2000,
  //  arrows: false,
  //  centerMode: true,
  //  centerPadding: '450px',
  //   cssEase: 'linear',
  //   pauseOnFocus: false,
  //   pauseOnHover: false,
  //   responsive: [
  //   {
  //     breakpoint: 1440,
  //     settings: {
  //        centerMode: true,
  //        centerPadding:'100px',
  //     }
  //   },
  //   {
  //     breakpoint: 767,
  //     settings: {
  //        centerMode: true,
  //        centerPadding:'60px',
  //        slidesToShow: 1,
  //     }
  //   },
  //    {
  //     breakpoint: 576,
  //     settings: {
  //       slidesToShow: 1,
  //        centerMode: true,
  //        centerPadding:'55px',
  //     }
  //   },
  //   {
  //     breakpoint: 370,
  //     settings: {
  //       slidesToShow: 1,
  //        centerMode: true,
  //        centerPadding:'30px',
  //     }
  //   }
  // ]
  // });

if ($(window).width() < 768) {
  $('.OS-pricing-table-inner').slick({
   slidesToShow: 1,
   infinite:true,
   slidesToScroll: 1,
   autoplay: false,
   arrows: false,
   centerMode: true,
   centerPadding:'150px',
    responsive: [
     {
      breakpoint: 576,
      settings: {
         centerMode: true,
         centerPadding:'100px',
      }
    },
    {
      breakpoint: 370,
      settings: {
        slidesToShow: 1,
         centerMode: true,
         centerPadding:'40px',
      }
    }
  ]
  });
}
  
if ($(window).width() < 576) {
  $('.service_flex').slick({
   slidesToShow: 2,
   infinite:true,
   slidesToScroll: 1,
   autoplay: true,
   autoplaySpeed: 2000,
   arrows: false
  });
}
// if ($(window).width() < 576) {
//   $('.OS_about_team_flex').slick({
//    slidesToShow: 3,
//    infinite:true,
//    slidesToScroll: 1,
//    autoplay: false,
//    autoplaySpeed: 2000,
//    arrows: false,
//    centerMode: true,
//    centerPadding:'270px',
    
//   });
// }
if ($(window).width() < 992) {
  $('.OS_work_detail_score_flex').slick({
   slidesToShow: 2,
   infinite:true,
   slidesToScroll: 1,
   autoplay: false,
   autoplaySpeed: 2000,
   arrows: false,
  centerMode: true,
   centerPadding:'100px',
     responsive: [
     {
      breakpoint: 768,
      settings: {
           slidesToShow: 1,
         centerMode: true,
         centerPadding:'120px',
      }
    },
    {
      breakpoint: 370,
      settings: {
        slidesToShow: 1,
         centerMode: true,
         centerPadding:'40px',
      }
    }
  ]
  });
}



$('.OS_website_img_flex').slick({
   slidesToShow: 3,
   infinite:true,
   slidesToScroll: 1,
   autoplay: true,
   autoplaySpeed: 1000,
   arrows: false,
      responsive: [
     {
      breakpoint: 992,
      settings: {
           slidesToShow: 2,
           slidesToScroll: 1,
      }
    },
    {
      breakpoint: 576,
      settings: {
       slidesToShow: 1,
           slidesToScroll: 1,
      }
    }
  ]
  });

  
  // // shopify partner popup js
  // $(".Click-here").on('click', function(event) {
  //   event.stopPropagation(); // Prevents the click event from bubbling up to the document
  //   $(".custom-model-main").toggleClass('model-open'); // Toggle the 'model-open' class
  // });
  // // Close the popup when clicking anywhere outside the popup content
  // $(document).on('click', function(event) {
  //     if (!$(event.target).closest('.custom-model-wrap').length && $('.custom-model-main').hasClass('model-open')) {
  //         $(".custom-model-main").removeClass('model-open');
  //     }
  // });
  // // Prevent closing when clicking inside the popup content, including images
  // $('.custom-model-wrap, .custom-model-wrap img').on('click', function(event) {
  //     event.stopPropagation(); // Prevents the click event from bubbling up to the document
  // });


  
  let notificationCount = 0;
  const maxVisiblePopups = 3;
  
  $(".Click-here").on('click', function(event) {
      event.stopPropagation(); 

      $('.shopify_logo_row img').css('animation','unset');
  
      // Increment the notification count
      notificationCount++;
      
      // Open the corresponding popup
      $(`.custom-model-main.popup-index-${notificationCount}`).addClass('model-open');

      // Play Sound Effect
      // $('#my-audio')[0].play(); // Correct way to access the audio DOM element

      // Play Sound Effect: Stop and play from the start
      const audioElement = $('#my-audio')[0];
      audioElement.pause();  // Stop the current playback
      audioElement.currentTime = 0;  // Reset the audio position to the start
      audioElement.play();  // Play the audio from the beginning

    
      
      // Ensure only the latest 3 popups are visible
      const visiblePopups = $(".custom-model-main.model-open");
      if (visiblePopups.length > maxVisiblePopups) {
          // Hide the first popup in the list (FIFO - First In, First Out)
          visiblePopups.first().removeClass('model-open');
      }
  });
  
  // Prevent closing when clicking inside the popup content
  $('.custom-model-wrap, .custom-model-wrap img').on('click', function(event) {
      event.stopPropagation(); 
  });
  // Close the popup when clicking anywhere outside the popup content
  $(document).on('click', function(event) {
      if (!$(event.target).closest('.custom-model-wrap').length && $('.custom-model-main').hasClass('model-open')) {
          $(".custom-model-main").removeClass('model-open');
          $('.shopify_logo_row img').css('animation','swinging 1.5s ease-in-out infinite');
      }
  });

  

  

  // Article tabify js
  $('.OS-tabs .art-title-tab').click(function(){
    var tab_id = $(this).attr('data-tab');
    console.log(tab_id, "tab_id");
    $('.OS-tabs .art-title-tab').removeClass('active');
    $('.blog-posts-by-tag').find('.blog-posts-by-tag-inner').removeClass('active');
    $(this).addClass('active');
    $("#"+tab_id).addClass('active');
  });


  $('.OS_about_slider_flex').slick({
   slidesToShow: 3,
   infinite:false,
   slidesToScroll: 2,
   autoplay: false,
   autoplaySpeed: 2000,
   // Speed: 2000,
   arrows: false,
   initialSlide: 0,
   variableWidth: true,
   cssEase: 'linear',
   responsive: [
     {
      breakpoint: 575,
      settings: {
         centerMode: true,
         slidesToShow: 1,
        centerPadding:'150px',
         variableWidth: false,
          infinite:false
      }
    }
  ]
  });

//    if ($(window).width() < 992) {
//    $('.blog_slider').slick({
//    slidesToShow: 1,
//    infinite:true,
//    slidesToScroll: 1,
//    autoplay: false,
//    autoplaySpeed: 1000,
//    arrows: false,
//    centerMode: true,
//    centerPadding:'170px',
//    initialSlide: 0,
//    responsive: [
//     {
//       breakpoint: 767,
//       settings: {
//          centerMode: true,
//          centerPadding:'80px',
//       }
//     },
//     {
//       breakpoint: 576,
//       settings: {
//          centerMode: true,
//          centerPadding:'70px',
//       }
//     },
//      {
//       breakpoint: 390,
//       settings: {
//          centerMode: true,
//          centerPadding:'40px',
//       }
//     }
//   ]
//   });
// }
  
});

// var featured_top = $(".Add-animation").position().top;
// $(window).scroll(function(){
//     if($(this).scrollTop() >= featured_top){
//         $(".OS_about_project_right p").addClass("anim");
//         $(".OS_about_project_right p").removeClass("anim_off");
//     } else {
//         $("..OS_about_project_right p").removeClass("anim");
//     }
// });

// $(document).ready(function() {
  // $("body video").each(function(index) {
  //   $(this).get(0).play();
  // });
  // setTimeout(function() {
  //   $("body video").each(function(index) {
  //     // Ensure the video is muted for autoplay to work in Safari
  //     $(this).prop('muted', true).get(0).play();
  //   });
  // }, 1000);
// });

$(document).ready(function() {
  setTimeout(function() {
    $("body video").each(function(index) {
      var videoElement = $(this).get(0);
      videoElement.muted = true;  // Mute the video for autoplay
      videoElement.playsInline = true;  // Allow inline playback on iOS
      videoElement.play();
      
      // Try to play the video and catch any potential errors
      videoElement.play().catch(function(error) {
        console.log('Autoplay failed:', error);
        // Handle the failure (e.g., show a play button for user interaction)
      });
    });
  }, 1500);
});



// On load animation


$(document).ready(function(){
  // Attach event listener to checkbox
  $("#Website_and_Design").change(function(){
    // Check if the checkbox is checked or not
    if ($(this).is(":checked")) {
      // $("#result").text("Website/Webshop is selected.");
      console.log("Website/Webshop is selected.");
      $(".contact-Budget_info .field-box-wrapper label:nth-child(2)").hide();
    } else {
      // $("#result").text("Website/Webshop is NOT selected.");
      console.log("Website/Webshop is NOT selected.");
      $(".contact-Budget_info .field-box-wrapper label:nth-child(2)").show();
    }
  });
});

// // Service Card Js
// var checkWidth1 = $(window).width();
// if (checkWidth1 >= 992) {
//     $(document).ready(function () {
//         $("#body").bind("mousewheel", function (e) {
//             if (e.originalEvent.wheelDelta / 120 > 0) {
//                 var num = $(".active").attr("data-section");
//                 num--;
//                 if (num <= -1) {
//                     num = num + 3;
//                 }
//                 $(".active").removeClass("active");
//                 $('.blog-posts-inner-block .stack_data[data-section="' + num + '"]').addClass("active");
//             } else {
//                 var num = $(".active").attr("data-section");
//                 num++;
//                 if (num >= 3) {
//                     num = 0;
//                 }
//                 $(".active").removeClass("active");
//                 $('.blog-posts-inner-block .stack_data[data-section="' + num + '"]').addClass("active");
//             }
//         });
//     });
//     $(window).scroll(function () {
//         var scrollDistance = $(window).scrollTop();
//         $(".stack_data ").each(function (i) {
//             if ($(this).position().top <= scrollDistance) {
//                 $(this).addClass("stack_card_active").siblings().removeClass("stack_card_active");
//             }
//         });
//     });
//     $(window).scroll();
// }



// Article
$(".metafield-rich_text_field li").wrapInner('<a></a>');
var ele = document.querySelectorAll(".metafield-rich_text_field li"); 
for (var metalist1 = 0; metalist1 < ele.length; metalist1++) {
    jQuery(ele[metalist1]).find('a').attr('href','#article_data' + metalist1);
}
var ele1 = document.querySelectorAll(".article_bottom_right_inner_info .article_inner_main "); 
for (var metadata = 0; metadata < ele1.length; metadata++) {
    jQuery(ele1[metadata]).attr('id','article_data' + metadata);
}


$(window).on('load', function() {
		$('.metafield-rich_text_field li a').click(function(e) {
			e.preventDefault();
            var target = $($(this).attr('href'));
            if(target.length){
              var scrollTo = target.offset().top - 130;
              $('body, html').animate({scrollTop: scrollTo+'px'}, 800);
            }
		});
});

$(window).scroll(function() {
		var scrollDistance = $(window).scrollTop() + 160;
		$('.article_inner_main ').each(function(i) {
				if ($(this).position().top <= scrollDistance) {
						$('.metafield-rich_text_field li.active').removeClass('active');
						$('.metafield-rich_text_field li').eq(i).addClass('active');
				}
		});
}).scroll();



$(document).ready(function() {
    if ($(window).width() > 767) {
     $('.recomanded-articles-wrapper .blog-posts-col').slick({
           slidesToShow: 1,
           infinite:true,
           slidesToScroll: 1,
           autoplay: false,
           autoplaySpeed: 1000,
           arrows: false,
           centerMode: true,
           centerPadding:'500px',
       responsive: [
    {
      breakpoint: 1400,
      settings: {
         centerMode: true,
         centerPadding:'200px',
      }
    },
    {
      breakpoint: 992,
      settings: {
         centerMode: true,
         centerPadding:'100px',
      }
    }
  ]
  });
  }
});


// // Back to Top
// var btn = $('#back_to_btn');
// $(window).scroll(function() {
//   var scrollPosition = $(window).scrollTop();
//   var documentHeight = $(document).height();
//   var scrollPercentage = (scrollPosition / documentHeight) * 100;
//   if (scrollPercentage > 87) {
//     btn.addClass('show');
//   } else {
//     btn.removeClass('show');
//   }
// });

// btn.on('click', function(e) {
//   e.preventDefault();
//   $('html, body').animate({scrollTop: 0}, 300);
// });




$(document).ready(function() {
    window._klOnsite = window._klOnsite || [];
    window._klOnsite.push(['openForm', 'SygDnR']);
});
